import React from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;
  handleSearch: (e: string) => void;
  handleApply: () => void;
  handleUpdateActive: (e: { value: string | number; label: string }[]) => void;
  selectedActive: { value: string | number; label: string }[];
  categories: string[];
  triggers: string[];
  selectedCategories: {
    value: string | number;
    label: string;
  }[];

  handleUpdateCategories: (
    e: { value: string | number; label: string }[],
  ) => void;

  selectedTriggers: {
    value: string | number;
    label: string;
  }[];

  handleUpdateTriggers: (
    e: { value: string | number; label: string }[],
  ) => void;
}
const NotificationsFilter: React.FC<Props> = ({
  searchValue,
  handleSearch,
  handleApply,
  handleUpdateActive,
  selectedActive,
  categories,
  triggers,
  selectedCategories,
  handleUpdateCategories,

  selectedTriggers,
  handleUpdateTriggers,
}) => {
  const { t } = useTranslation();

  const handleApplyActive = (
    e: { value: string | number; label: string }[],
  ) => {
    handleUpdateActive(e);
  };

  const handleClearFilters = () => {
    handleApplyActive([]);
    handleSearch("");
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  const categoryOptions =
    categories?.map((item) => ({
      value: item,
      label: item,
    })) ?? [];

  const triggerOptions =
    triggers?.map((item) => ({
      value: item,
      label: item,
    })) ?? [];

    const isAuto = location.pathname.includes("auto");

  const handleApplyCategories = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateCategories(isDelete ? e : [...selectedCategories, ...e]);
  };

  const handleApplyTriggers = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateTriggers(isDelete ? e : [...selectedTriggers, ...e]);
  };


  return (
    <Filter
      className="notifications-filter"
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: searchValue,
          setInputValue: handleSearch,
        },
        {
          type: FilterItemTypes.radio,
          title: t("isActive"),
          boxTitle: t("isActive"),
          icon: gridIcon,
          itemsArray: [
            {
              label: "Active",
              value: 1,
            },
            {
              label: "Inactive",
              value: 0,
            },
            {
              label: "All",
              value: 3,
            },
          ],
          activeItems: selectedActive,
          handleApply: handleApplyActive,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("category"),
          boxTitle: t("category"),
          icon: gridIcon,
          itemsArray: categoryOptions,
          activeItems: selectedCategories,
          handleApply: handleApplyCategories,
          disabled: categoryOptions.length === 0,
        },
        ...(isAuto
          ? [
              {
                type: FilterItemTypes.multiselect,
                title: t("trigger"),
                boxTitle: t("trigger"),
                icon: gridIcon,
                itemsArray: triggerOptions,
                activeItems: selectedTriggers,
                handleApply: handleApplyTriggers,
                disabled: triggerOptions.length === 0,
              },
            ]
          : []),
      ]}
    />
  );
};

export default NotificationsFilter;
